import { applySignatureHeaders, getApiKey, isSignatureEnabled } from '@/utils/api-signature';

/**
 * 請求攔截器：為介面請求附加前後端簽名校驗資料
 * （X-Api-Key / X-Timestamp / X-Nonce / X-Signature，規則見 src/utils/api-signature.js）。
 *
 * 說明：
 * - 沒有配置 apiKey 時不加任何請求頭，行為與接入前完全一致；
 * - 配置了 apiKey 但想臨時關閉，可設 API_SIGNATURE_ENABLE=0（見 README）；
 * - 單個介面可以在 api 定義裡傳 signature: false 明確跳過，
 *   也可以傳 signature: true 在整體關閉時單獨開啟。
 */
export default function signatureInterceptor(config) {
  if (!config) {
    return config;
  }

  // 明確標記不需要簽名的介面（例如第三方網域）直接放行
  if (config.signature === false) {
    return config;
  }

  const apiKey = getApiKey();
  if (!apiKey) {
    return config;
  }

  if (config.signature !== true && !isSignatureEnabled()) {
    return config;
  }

  return applySignatureHeaders(config, { apiKey });
}
